/*
 * SPDX-FileCopyrightText: © 2024 Schneider Electric
 *
 * SPDX-License-Identifier: Apache-2.0
 */

@import url('../shared.css');

:host {
  display: contents;
}

.qds-table-head-cell {
  box-sizing: border-box;
  color: var(--qds-theme-title);
  font: var(--qds-list-item-standard-title);
  padding-block: var(--qds-list-item-standard-padding-vertical);
  padding-inline: var(--qds-list-item-standard-padding-horizontal);
  text-align: inherit;
  vertical-align: middle;
  width: inherit;
}
